import { MIN_WIDTH_COL_RESIZE } from "./p-table.js";
import { ref, onMounted, onBeforeUnmount, watch, nextTick } from "vue";
const usePTableColResize = (options) => {
  const { enabled, ths } = options;
  const isColResizing = ref(false);
  const colResizeHandleLeft = ref("0px");
  const colResizingWidth = ref(0);
  const colResizingIndex = ref(-1);
  const colResize = (e) => {
    colResizeHandleLeft.value = `${e.clientX}px`;
    if (isColResizing.value) {
      document.body.classList.add("cursor-col-resize");
      const th = ths.value[colResizingIndex.value];
      const rect = th.getBoundingClientRect();
      const diff = e.clientX - rect.left - th.offsetWidth;
      const widthToSet = th.offsetWidth + diff;
      setColResizingWidth(widthToSet);
      colResizeHandleLeft.value = e.clientX < rect.left ? "0px" : `${e.clientX}px`;
    }
  };
  const colResizeStart = (e, i) => {
    if (e.detail === 1) {
      e.preventDefault();
      isColResizing.value = true;
      colResizingWidth.value = ths.value[i].offsetWidth;
      colResizingIndex.value = i;
    }
  };
  const colResizeStop = () => {
    if (!isColResizing.value) {
      return;
    }
    isColResizing.value = false;
    document.body.classList.remove("cursor-col-resize");
  };
  const colResizeFitToData = (colIndex) => {
    var _a;
    isColResizing.value = true;
    const tds = (_a = ths.value[colIndex].closest("table")) == null ? void 0 : _a.querySelectorAll("tbody tr td:nth-child(" + (colIndex + 1) + ") div.w-max");
    if (!tds) {
      return;
    }
    const maxWidth = [...tds].reduce((max, td) => {
      const width = td.getBoundingClientRect().width;
      return width > max ? width : max;
    }, 0);
    setColResizingWidth(maxWidth);
    nextTick(() => {
      isColResizing.value = false;
    });
  };
  const setColResizingWidth = (width) => {
    colResizingWidth.value = width > MIN_WIDTH_COL_RESIZE ? Math.ceil(width) : MIN_WIDTH_COL_RESIZE;
  };
  onMounted(() => {
    enabled.value && document.addEventListener("mouseup", colResizeStop);
  });
  onBeforeUnmount(() => {
    enabled.value && document.removeEventListener("mouseup", colResizeStop);
  });
  watch(enabled, (nV) => {
    if (nV) {
      document.addEventListener("mouseup", colResizeStop);
    } else {
      document.removeEventListener("mouseup", colResizeStop);
    }
  });
  return {
    isColResizing,
    colResizeHandleLeft,
    colResizingIndex,
    colResizingWidth,
    colResize,
    colResizeStart,
    colResizeStop,
    colResizeFitToData
  };
};
export {
  usePTableColResize
};
